import { createSlice } from "@reduxjs/toolkit";

const Categorysclice = createSlice({
  name: "category",
  initialState: {
    Categoryloading: false,
    insertdata: null,
    Categoryerror: null,

    editcategoryloading: false,
    editcategorydata: null,
    editcategoryerror: null,

    subcategoryloading: false,
    subinsertdata: null,
    subcategoryerror: null,

    subeditcategoryloading: false,
    subeditcategorydata: null,
    subeditcategoryerror: null,

    getSubcategoryloading: false,
    getSubcategorydata: null,
    getSubcategoryerror: null,

    getProductbysubcategoryloading: false,
    getProductbysubcategorydata: null,
    getProductbysubcategoryerror: null,

    deletecategoryloading: false,
    deletecategorydata: null,
    deletecategoryerror: null,

    deletesubcategoryloading: false,
    deletesubcategorydata: null,
    deletesubcategoryerror: null,

    getsubcategorybycategoryidloading: false,
    getsubcategorybycategoryiddata: null,
    getsubcategorybycategoryiderror: null,
  },
  reducers: {
    insertCategoryRequest: (state) => {
      state.Categoryloading = true;
      state.Categoryerror = null;
    },
    insertCategorySuccess: (state, action) => {
      state.Categoryloading = false;
      state.insertdata = action.payload;
    },
    insertCategoryFailure: (state, action) => {
      state.Categoryloading = false;
      state.Categoryerror = action.payload;
    },

    editCategoryRequest: (state) => {
      state.editcategoryloading = true;
      state.editcategoryerror = null;
    },
    editCategorySuccess: (state, action) => {
      state.editcategoryloading = false;
      state.editcategorydata = action.payload;
    },
    editCategoryFailure: (state, action) => {
      state.editcategoryloading = false;
      state.editcategoryerror = action.payload;
    },

    insertSubCategoryRequest: (state) => {
      state.subcategoryloading = true;
      state.subcategoryerror = null;
    },
    insertSubCategorySuccess: (state, action) => {
      state.subcategoryloading = false;
      state.subinsertdata = action.payload;
    },
    insertSubCategoryFailure: (state, action) => {
      state.subcategoryloading = false;
      state.subcategoryerror = action.payload;
    },

    editSubCategoryRequest: (state) => {
      state.subeditcategoryloading = true;
      state.subeditcategoryerror = null;
    },
    editSubCategorySuccess: (state, action) => {
      state.subeditcategoryloading = false;
      state.subeditcategorydata = action.payload;
    },
    editSubCategoryFailure: (state, action) => {
      state.subeditcategoryloading = false;
      state.subeditcategoryerror = action.payload;
    },

    getSubcategoryRequest: (state) => {
      state.getSubcategoryloading = true;
      state.getSubcategoryerror = null;
    },
    getSubcategorySuccess: (state, action) => {
      state.getSubcategoryloading = false;
      state.getSubcategorydata = action.payload;
    },
    getSubcategoryFailure: (state, action) => {
      state.getSubcategoryloading = false;
      state.getSubcategoryerror = action.payload;
    },
    getProductbysubcategoryRequest: (state) => {
      state.getProductbysubcategoryloading = true;
      state.getProductbysubcategoryerror = null;
    },
    getProductbysubcategorySuccess: (state, action) => {
      state.getProductbysubcategoryloading = false;
      state.getProductbysubcategorydata = action.payload;
    },
    getProductbysubcategoryFailure: (state, action) => {
      state.getProductbysubcategoryloading = false;
      state.getProductbysubcategoryerror = action.payload;
    },
    deleteCategoryRequest: (state) => {
      state.deletecategoryloading = true;
      state.deletecategoryerror = null;
    },
    deleteCategorySuccess: (state, action) => {
      state.deletecategoryloading = false;
      state.deletecategorydata = action.payload;
    },
    deleteCategoryFailure: (state, action) => {
      state.deletecategoryloading = false;
      state.deletecategoryerror = action.payload;
    },
    deleteSubCategoryRequest: (state) => {
      state.deletesubcategoryloading = true;
      state.deletesubcategoryerror = null;
    },
    deleteSubCategorySuccess: (state, action) => {
      state.deletesubcategoryloading = false;
      state.deletesubcategorydata = action.payload;
    },
    deleteSubCategoryFailure: (state, action) => {
      state.deletesubcategoryloading = false;
      state.deletesubcategoryerror = action.payload;
    },
    getsubcategorybycategoryidRequest: (state) => {
      state.getsubcategorybycategoryidloading = true;
      state.getsubcategorybycategoryiderror = null;
    },
    getsubcategorybycategoryidSuccess: (state, action) => {
      state.getsubcategorybycategoryidloading = false;
      state.getsubcategorybycategoryiddata = action.payload;
    },
    getsubcategorybycategoryidFailure: (state, action) => {
      state.getsubcategorybycategoryidloading = false;
      state.getsubcategorybycategoryiderror = action.payload;
    },
  },
});

export const {
  insertCategoryRequest,
  insertCategorySuccess,
  insertCategoryFailure,
  editCategoryRequest,
  editCategorySuccess,
  editCategoryFailure,

  insertSubCategoryRequest,
  insertSubCategorySuccess,
  insertSubCategoryFailure,

  editSubCategoryRequest,
  editSubCategorySuccess,
  editSubCategoryFailure,

  getSubcategoryRequest,
  getSubcategorySuccess,
  getSubcategoryFailure,

  getProductbysubcategoryRequest,
  getProductbysubcategorySuccess,
  getProductbysubcategoryFailure,

  deleteCategoryRequest,
  deleteCategorySuccess,
  deleteCategoryFailure,

  deleteSubCategoryRequest,
  deleteSubCategorySuccess,
  deleteSubCategoryFailure,

  getsubcategorybycategoryidRequest,
  getsubcategorybycategoryidSuccess,
  getsubcategorybycategoryidFailure,
} = Categorysclice.actions;

export default Categorysclice.reducer;
